// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import spsHelper from '@/pages/customerarea/payment/spsHelper';
import { errorReport } from '@/_helper/errorReport';
import PaymentError from '@/class/error/PaymentError';
import { PaymentType } from '@/model/common/PaymentType';
import { Icon } from '@/comp/icon/icon.tsx';

const params = {
    errorWording: {
        holder: {
            default: 'Bitte geben Sie einen Inhaber ein.',
            invalid: 'Bitte geben Sie einen gültigen Inhaber ein.',
        },
        number: {
            default: 'Bitte geben Sie eine Kreditkartennummer ein.',
            length: 'Bitte prüfen Sie die Länge Ihrer Kreditkartennummer.',
        },
        expiryDate: {
            default: 'Bitte geben Sie das Gültigkeitsdatum ein.',
            invalid: 'Bitte geben Sie ein gültiges Datum ein.',
        },
        cvc: {
            default: 'Bitte geben Sie den Sicherheitscode ein.',
            length: 'Bitte prüfen Sie die Länge Ihres Sicherheitscodes.',
        },
    },
};

let sps;

class CreditCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValid: false,
            isLoading: true,
            formErrors: {
                holder: params.errorWording.holder.default,
                number: params.errorWording.number.default,
                expiryDate: params.errorWording.expiryDate.default,
                cvc: params.errorWording.cvc.default,
            },
            unsetPaymentTypes: {
                creditCard: { title: 'Kreditkarte' },
            },
        };

        try {
            sps = new spsHelper(props.spsUrl);
            sps.loadJquery(this.initCreditCard.bind(this));
        } catch (error) {
            errorReport(error instanceof PaymentError ? error.toString() : error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.formValid && !this.state.formValid) {
            const paymentData = Object.assign(this.props.paymentData, {
                paymentValid: false,
            });
            this.props.setPaymentData(paymentData);
        }

        if (!prevProps.active && this.props.active && window.sps) {
            try {
                this.initCreditCard();
            } catch (error) {
                errorReport(error instanceof PaymentError ? error.toString() : error);
            }
        }
    }

    initCreditCard() {
        this.setState({
            spsloadSuccess: false,
            isLoading: true,
        });

        const interval = setInterval(function () {
            if (window.C24SpsClient !== undefined && window.C24SpsClient.defaults !== undefined) {
                clearInterval(interval);
                createSPSEvents();
            }
        }, 500);

        const createSPSEvents = () => {
            let $this = this;
            spsHelper.initSps();

            let colorThemeGrey = '#929292';

            window.sps = new window.C24SpsClient('creditCard', {
                fieldStyles: {
                    '.c24-sps-input': {
                        'font-family': 'Open Sans, sans-serif',
                        border: `1px solid  ${colorThemeGrey}`,
                        'border-radius': '5px',
                        'font-size': '16px',
                        'font-weight': '400',
                    },
                    '.c24-sps-input:hover': {
                        'border-color': colorThemeGrey,
                    },
                    '.c24-sps-input:focus': {
                        'border-color': colorThemeGrey,
                    },
                },
                errorTemplate: '<div class="error text-red"></div>',
                onInput: function (spsEvent) {
                    if (!spsEvent.isValid) {
                        $this.setState({ formValid: false });
                    }
                },
                onChange: function (spsEvent) {
                    if (!spsEvent.isValid) {
                        $this.setState({ formValid: false });
                    }
                },
                onError: function ($hostedField, error) {
                    $this.setState({ formValid: false });
                    throw new PaymentError(
                        `iframe could not be loaded on hostedField: ${$hostedField}`,
                        PaymentType.CreditCard,
                        null,
                        [error]
                    );
                },
                onGroupValidationSuccess: () => {
                    /*
                     TODO: later better fix this shit
                     if ( spsEvent.isGroupValid ) {
                         $this.state.paymentData.paymentValid = true;
                     }

                    let paymentChange = {
                        pageLoad : true,
                        paymentData : $this.state.paymentData
                    }

                     $this.props.paymentChange(paymentChange)
                      */
                },
                onSubmit: (spsEvent) => {
                    if (spsEvent.isValid) {
                        const d = spsEvent.creditcard.expiry_date.split('/');
                        const expirationDate = d[2] + '-' + d[1] + '-' + d[0];

                        const paymentData = Object.assign($this.props.paymentData, {
                            paymentValid: true,
                            creditCard: {
                                paymentDataType: 'creditCard_sps',
                                accountOwner: spsEvent.creditcard.name,
                                accountNumber: spsEvent.creditcard.number_short,
                                securityNumber: '***',
                                institute: spsEvent.creditcard.type,
                                expirationDate: expirationDate,
                                externalOrderNumber: spsEvent.creditcard.token,
                            },
                        });
                        this.props.setPaymentData(paymentData);

                        this.setState({
                            formValid: true,
                            paymentData: paymentData,
                        });
                    } else {
                        const paymentData = Object.assign($this.props.paymentData, {
                            paymentValid: false,
                        });

                        this.setState({
                            formValid: false,
                            paymentData: paymentData,
                        });
                        this.props.setPaymentData(paymentData);
                    }

                    return false;
                },
                onLoad: () => {
                    $this.setState({
                        spsloadSuccess: true,
                        isLoading: false,
                    });
                },
                on3dSecure2Success: (transactionIdentifier) => {
                    this.props.handleCreditCardSuccess(transactionIdentifier);
                    window.dispatchEvent(
                        new CustomEvent('native.3DS2Success', {
                            detail: {
                                transactionIdentifier: transactionIdentifier,
                            },
                        })
                    );
                },
                on3dSecure2Failed: (transactionIdentifier, errors) => {
                    // error
                    const paymentChange = {
                        requestError: true,
                    };
                    this.props.paymentChange(paymentChange);

                    throw new PaymentError(
                        '3D-Secure authentication failed (or canceled by the user)',
                        PaymentType.CreditCard,
                        transactionIdentifier,
                        errors
                    );
                },
                on3dSecure2UserCanceled: () => {
                    // error
                    const paymentChange = {
                        requestError: true,
                    };
                    this.props.paymentChange(paymentChange);
                },
                on3dSecure2CardNotReady: () => {
                    // error
                    const paymentChange = {
                        requestError: true,
                        errorText: window.$content.errorPaymentText['3dSecure2CardNotReady'],
                    };

                    this.props.paymentChange(paymentChange);
                },
                onRiskCollectionError: (transactionIdentifier) => {
                    throw new PaymentError(
                        'an error occurred during the risk data collection',
                        PaymentType.CreditCard,
                        transactionIdentifier
                    );
                },
            });

            if (!this.state.spsInit) {
                this.setState({
                    spsInit: true,
                    spsloadSuccess: true,
                    isLoading: false,
                });
            }

            Object.assign(this.props.paymentData, {
                selected: 'creditCard',
            });
        };
    }

    getsFormElements() {
        return (
            <div className={`form-elements`}>
                <div className="form-row">
                    <label htmlFor="creditCardNumber">Kreditkartennummer</label>
                    <div data-c24-sps-group="creditCard" className="field-cnt" data-c24-sps-field="number"></div>
                </div>
                <div className="form-row">
                    <label htmlFor="creditCardName">Name auf der Karte</label>
                    <div
                        className="field-cnt"
                        data-c24-sps-group="creditCard"
                        data-c24-sps-field="name"
                        data-c24-sps-value=""></div>
                </div>
                <div className="form-row">
                    <div>
                        <label htmlFor="creditCardExpiry">Gültig bis</label>
                        <div
                            id="creditCardExpiry"
                            className="field-cnt"
                            data-c24-sps-group="creditCard"
                            data-c24-sps-field="expiry_date"></div>
                    </div>
                    <div>
                        <label htmlFor="creditCardValidationCode">Kartenprüfnummer</label>
                        <div className="field-cnt" data-c24-sps-group="creditCard" data-c24-sps-field="cvc"></div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                {!this.state.spsInit && this.props.active && (
                    <div className="loading card-loading lazy-load-background">
                        <div className="loading-card-row">
                            <span className="loading-label"></span>
                            <span className="loading-input"></span>
                        </div>
                        <div className="loading-card-row">
                            <span className="loading-label"></span>
                            <span className="loading-input"></span>
                        </div>
                        <div className="loading-card-row">
                            <div>
                                <span className="loading-label"></span>
                                <span className="loading-input"></span>
                            </div>
                            <div>
                                <span className="loading-label"></span>
                                <span className="loading-input"></span>
                            </div>
                        </div>
                    </div>
                )}
                {this.props.active && (
                    <div className={`card-body ${this.props.active && this.state.spsInit && 'active'}`}>
                        {this.getsFormElements()}
                        <div className="trust-element">
                            <Icon name="check" ariaHidden />
                            Die Übertragung Ihrer Zahldaten erfolgt verschlüsselt über einen Sicherheitsserver.
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default CreditCard;
